import { useState, useEffect } from "react";

export const getSvgElement = (el: Element) => {
  let parent: Element | null = el;
  while (parent && parent.tagName !== "svg") {
    parent = parent.parentElement;
  }

  if (parent) {
    return parent as SVGElement;
  }

  return null;
};

export const useDimensions = (el: HTMLElement | SVGElement | null) => {
  const [dimensions, setDimensions] = useState<DOMRect>(new DOMRect());

  useEffect(() => {
    if (!el) {
      return;
    }

    const onResize = (entries: ResizeObserverEntry[]) => {
      setDimensions(entries[0].target.getBoundingClientRect());
    };

    const observer = new ResizeObserver(onResize);
    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, [el]);

  return dimensions;
};

export type Placement = {
  economyCode: string;
  y: number;
}[];

export const positionY = ({
  y,
  height,
  economyCode,
  placement,
}: {
  y: number;
  height: number;
  economyCode: string;
  placement: Placement;
}) => {
  let labelY = y;
  let isDone = false;

  // Increase the label y until it doesn't overlap with any other labels
  while (!isDone) {
    const existingLabel = placement.find(
      (t) =>
        t.y >= labelY - height &&
        t.y <= labelY + height &&
        t.economyCode !== economyCode
    );

    if (!existingLabel) {
      isDone = true;
      break;
    }

    labelY = existingLabel.y + height + 1;
  }

  placement.push({ y: labelY, economyCode });

  return labelY;
};
